export default "__VITE_ASSET__DZnofIyN__"